export default __webpack_public_path__ + "static/media/YearForecast.49698f69.svg";